module.exports = __webpack_public_path__ + "assets/8a249d69e70235a406e6bb907a45a48d.mp3";